<div class="page-footer">
  <p>ProjectZen, 6 Liberty Square #2334, Boston, MA 02109</p>
  <a href="terms">Terms</a>
  <a href="privacy">Privacy</a>
  @if(displayHelp()) {
    <a href="mailto:help@projectzen.com">Help</a>
  }
</div>